import { prefix } from "../../design-tokens/meta";

export const componentName = "InputMask";

export const componentClasses = Object.freeze({
    input: `${prefix}input-text`,
    validated: `${prefix}input-text--invalid`,
    errorIcon: `${prefix}input-text__icon--end`,
});

export const views = Object.freeze({
    valid: {
        attrs: { "aria-invalid": "false" },
    },
    invalid: {
        attrs: { "aria-invalid": "true" },
    },
    validated: {
        classList: [`${componentClasses.validated}`],
    },
});

export const applyMask = (mask, maskChar, element) => {
    const enteredValue = element.value.split("").filter((i) => {
        return i.match(/[0-9]/g);
    });
    const mappedValue = mask.map((char, index) => {
        return char === maskChar
            ? { char, index, value: null, replace: true }
            : { char, index, replace: false };
    });
    mappedValue.forEach((item, i) => {
        if (item.char !== maskChar && i <= enteredValue.length) {
            enteredValue.splice(item.index, 0, item.char);
        }
    });
    if (enteredValue.length > mappedValue.length) {
        enteredValue.pop();
    }
    let maskedValue = enteredValue.join("");
    if (!maskedValue.match(/[0-9]/g)) {
        maskedValue = "";
    }
    return maskedValue;
};

export const maskInitChars = {
    numberChar: "9",
};
